<div class="claim-form-container">
  <form [formGroup]="vm.claimForm" (ngSubmit)="onSubmit()" class="claim-form">
    <!-- Question Header -->
    <div class="question-header">
      <h3 [innerHTML]="vm.currentQuestion.questionLabel"></h3>
      <p *ngIf="vm.currentQuestion.questionHelp" class="question-help">
        {{ vm.currentQuestion.questionHelp }}
      </p>
    </div>

    <!-- Radio Button Group -->
    <ng-container *ngIf="selectedQuestionType === 'RADIO_BUTTONS'">
      <div
        class="radio-group"
        [class.has-error]="selectedAnswer?.invalid && selectedAnswer?.touched"
      >
        <label
          class="radio-option"
          *ngFor="let option of vm.currentQuestion.answerData"
        >
          <input
            type="radio"
            [value]="option.answerID"
            formControlName="selectedAnswer"
            [id]="'answer-' + option.answerID"
          />
          <span class="radio-custom"></span>
          <span class="radio-label">{{ option.answerLabel }}</span>
        </label>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedQuestionType === 'RESPONSE_FIELD'">
      <div>
        <textarea [formControl]="vm.claimForm.controls['selectedAnswer']">
        </textarea>
      </div>
    </ng-container>

    <!-- Error Message -->
    <div
      class="error-message"
      *ngIf="selectedAnswer?.invalid && selectedAnswer?.touched"
    >
      Please select an option
    </div>

    <!-- Submit Button -->
    <div class="form-actions">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="vm.claimForm.invalid"
      >
        Submit Answer
      </button>

      <button
        type="button"
        class="btn btn-secondary"
        (click)="vm.claimForm.reset()"
      >
        Reset
      </button>
    </div>

    <!-- Debug Info (remove in production) -->
    <div class="debug-info" *ngIf="false">
      <h4>Debug Information:</h4>
      <p>Form Valid: {{ vm.claimForm.valid }}</p>
      <p>Form Value: {{ vm.claimForm.value | json }}</p>
      <p>Selected Answer Errors: {{ selectedAnswer?.errors | json }}</p>
    </div>
  </form>
</div>
